function debounce(func, wait, immediate) {
	let timeout;
	return function () {
		let context = this,
			args = arguments;
		let callNow = immediate && !timeout;

		clearTimeout(timeout);

		timeout = setTimeout(function () {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		}, wait);

		if (callNow) {
			func.apply(context, args);
		}
	};
}

(function (w, $) {
	const $d = $(document);
	let timeout = null;

	const startCoutdown = () => {
		if (timeout) {
			return;
		}

		timeout = setTimeout(() => {
			$('.widget-cart-container').fadeTo(500, 0, function () {
				$(this).hide();
			});
			timeout = null;
		}, 5000);
	};

	$(function () {
		$(document.body).on('added_to_cart', function (e, fragments) {
			if (!fragments) {
				return;
			}

			if (fragments['sl-cart-count']) {
				const cartTotal = parseInt(fragments['sl-cart-count']);
				$('header .cart-count').html(cartTotal);
			}

			if (fragments['div.widget_shopping_cart_content']) {
				$('.widget-cart-container').html(fragments['div.widget_shopping_cart_content']).css('visibility', 'visible').hide().fadeTo(500, 1);
				startCoutdown();
			}
		});

		$d.on('mouseenter', '.widget-cart-container', function () {
			clearTimeout(timeout);
			timeout = null;
		});

		$d.on('mouseleave', '.widget-cart-container', startCoutdown);

		$d.on('click', '.widget-cart-container .close-widget-cart', function () {
			$('.widget-cart-container').fadeTo(500, 0, function () {
				$(this).hide();
			});
		});
	});

	$d.ready(function () {
		function updateTestimonialCount() {
			const testimonialCount = $('#testimonials .testimonial').length;
			const $testimonialCarousel = $('#testimonials .testimonials-carousel');

			if ($testimonialCarousel.hasClass('owl-carousel')) {
				$testimonialCarousel.trigger('destroy.owl.carousel').removeClass('owl-carousel');
			}
			if ($(window).width() < 1199) {
				$testimonialCarousel.addClass('owl-carousel').owlCarousel({
					items: Math.min(testimonialCount, 3),
					loop: true,
				});
			} else {
				if (testimonialCount > 3) {
					$testimonialCarousel.addClass('owl-carousel').owlCarousel({
						items: Math.min(testimonialCount, 3),
						loop: false,
					});
				}
			}
		}

		$('#hero .product-images').owlCarousel({
			items: 1,
			touchDrag: false,
			mouseDrag: false,
			responsive: { 0: { items: 1 }, 400: { items: 1 }, 740: { items: 1 }, 940: { items: 1 } },
			autoplay: true,
			autoplayTimeout: 4000,
			dots: false,
			rtl: true,
		});

		$('#hero .text-slider-container').owlCarousel({
			items: 1,
			touchDrag: false,
			mouseDrag: false,
			responsive: { 0: { items: 1 }, 400: { items: 1 }, 740: { items: 1 }, 940: { items: 1 } },
			autoplay: true,
			autoplayTimeout: 4000,
			dots: false,
		});

		if ($(window).width() < 768) {
			$('.page-template-template-home #products .products').addClass('owl-carousel').owlCarousel({
				items: 1,
				nav: true,
				dots: false,
				autoplay: true,
			});
		}

		if ($(window).width() < 1200) {
			$('#attributes .attributes')
				.addClass('owl-carousel')
				.owlCarousel({
					items: 1,
					autoplayTimeout: 3000,
					dots: false,
					responsive: {
						0: { items: 1 },
						500: { items: 2 },
						700: { items: 3 },
						900: { items: 4 },
					},
					autoplay: true,
				});
		}

		function updateProductCatsCarousel() {
			if ($(window).width() < 768) {
				$('#product-categories .product-categories').addClass('owl-carousel').owlCarousel({ margin: 30 });
			} else {
				$('#product-categories .product-categories').trigger('destroy.owl.carousel').removeClass('owl-carousel');
			}
		}

		function updateProductsCarousel() {
			if ($('#products .container').data('carousel')) {
				if ($(window).width() < 992) {
					if (!$('#products .container .products').hasClass('owl-carousel')) {
						$('#products .container .products')
							.addClass('owl-carousel')
							.owlCarousel({
								items: 1,
								nav: true,
								navText: ['←', '→'],
							});
					}
				} else {
					if ($('#products .container .products').hasClass('owl-carousel')) {
						$('#products .container .products').trigger('destroy.owl.carousel').removeClass('owl-carousel');
					}
				}
			}
		}

		updateProductsCarousel();
		updateProductCatsCarousel();
		updateTestimonialCount();

		$(w).resize(function () {
			updateProductsCarousel();
			updateProductCatsCarousel();
			updateTestimonialCount();
		});
	});

	$d.ready(function () {
		$('form.cart').on('click', 'button.plus, button.minus', function () {
			let qty = $(this).closest('form.cart').find('.qty');
			let val = parseFloat(qty.val());
			let max = parseFloat(qty.attr('max'));
			let min = parseFloat(qty.attr('min'));
			let step = parseFloat(qty.attr('step'));

			// Change the value if plus or minus
			if ($(this).is('.plus')) {
				if (max && max <= val) {
					qty.val(max);
				} else {
					qty.val(val + step);
				}
			} else {
				if (min && min >= val) {
					qty.val(min);
				} else if (val > 1) {
					qty.val(val - step);
				}
			}
		});
	});
})(window, jQuery);

jQuery(function ($) {
	$('.burger, .overlay, .cross').on('click', function () {
		$('.burger, .overlay, nav').toggleClass('active');
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const faqTitles = document.querySelectorAll('.faq-title');

	faqTitles.forEach(function (title) {
		const faqContent = title.nextElementSibling;
		const icon = title.querySelector('.icon');

		if (faqContent.style.display === '' || faqContent.style.display === 'none') {
			icon.textContent = '+';
		}

		title.addEventListener('click', function () {
			const isOpen = faqContent.classList.contains('open');
			if (isOpen) {
				faqContent.classList.remove('open');
				icon.textContent = '+';
			} else {
				faqContent.classList.add('open');
				icon.textContent = '-';
			}
		});
	});
});

// Faceting sidebar
jQuery(function ($) {
	//prevents premptive height reset
	let matchHeightDebounced = debounce(function () {
		$('.facetable-container .facetable:not(.hidden)').matchHeight();
	}, 50);

	// caching
	let $form = $('.faceting form');
	let $items = $('.facetable-container .facetable');
	let $noItemItem = $('.facetable-container .no-items-in-filter');
	let $pagination = $('.facetable-container .pagination');
	let $paginationButtons = $pagination.find('.pagination-inner .pagination-pages > div');
	let $paginationDirectionButtons = $pagination.find('.pagination-inner .pagination-direction');
	let currentPage = 1;
	let pageSize = 6;

	$form.on('change', '#product-filter', function () {
		let pid = parseInt(this.value);

		if (pid) {
			window.location.search = '&pid=' + this.value;
		} else {
			window.location.search = '';
		}
	});

	// run filtering when inputs change
	$form.on('change', 'li input', function () {
		$form.trigger('updateFilter');
	});

	// filter items
	$form.on('updateFilter', function () {
		// 2d array where each of the 1ds are ANDed with each other
		// and the 2nds are ORed
		let activeItems = [];
		$form.find('fieldset').each(function (i, fieldset) {
			activeItems.push([]);
			$(fieldset)
				.find('input[type="checkbox"]:checked')
				.each(function (j, el) {
					activeItems[i].push($(el).attr('data-id'));
				});
		});

		$items.each(function (i, el) {
			let $item = $(el);
			let tags = $item.attr('data-terms').split(',');

			// loop through all 1ds AND= the any intersections between them
			let isIntersection = true;
			$.each(activeItems, function (j, matchArr) {
				// if the filter is not ticked, show all
				if (matchArr.length <= 0) {
					return true;
				}

				isIntersection &=
					matchArr.filter(function (match) {
						return tags.indexOf(match) >= 0;
					}).length > 0;
			});

			$item.toggleClass('hidden', !isIntersection);
		});

		$form.trigger('filterUpdated');
	});

	// when filter has been updated, show/hide the "no posts" thing,
	// and trigger pagination to run
	$form.on('filterUpdated', function () {
		let noItemsVisible = $items.filter(':not(.hidden)').length <= 0;
		$noItemItem.toggleClass('hidden', !noItemsVisible);
		$pagination.trigger('runPagination');
	});

	// reset the filtering by unchecking all checkboes and trigger filtering
	$noItemItem.on('click', '#filter-reset', function (e) {
		e.preventDefault();
		$form.find('li input').prop('checked', false);
		$form.trigger('updateFilter');
	});

	// run pagination, and if no pageNumber is passed it, just reevaluate
	// with the current page number
	$pagination.on('runPagination', function (e, pageNumber) {
		if (!pageNumber) {
			pageNumber = currentPage;
		}

		if (pageNumber <= 0) {
			pageNumber = 1;
		}

		let $filteredItems = $items.filter(':not(.hidden)');

		$filteredItems.each(function (i, item) {
			let pageThisItemIsOn = Math.ceil((i + 1) / pageSize);
			// note the use of the different class here so that we can still use 'hidden' to
			// find only items which come through the filter

			let $item = $(item);

			//Recipe images
			if (pageThisItemIsOn === pageNumber) {
				let $imgTag = $item.find('.image-container div');
				let src = $imgTag.data('image');
				$imgTag.css('background-image', 'url(' + src + ')');
			}

			$item.toggleClass('pagination-hidden', pageThisItemIsOn !== pageNumber);
		});

		// show the correct number of pagination buttons
		let totalButtonsRequried = Math.ceil($filteredItems.length / pageSize);
		$paginationButtons.each(function (i, button) {
			$(button).toggleClass('hidden', i >= totalButtonsRequried);
		});
		// and hide the directional arrows if one page or less
		$paginationDirectionButtons.toggleClass('hidden', totalButtonsRequried <= 1);

		// set the correct pagination button active class
		$paginationButtons.removeClass('active');
		$paginationButtons.eq(pageNumber - 1).addClass('active');

		currentPage = pageNumber;

		// if the current page is more than the total buttons, this means that
		// we would be showing a blank page, so lets run the pagination
		// with the last button
		if (totalButtonsRequried >= 1 && pageNumber > totalButtonsRequried) {
			$pagination.trigger('runPagination', [totalButtonsRequried]);
		}

		matchHeightDebounced();
	});

	// handle pagination button clicks
	$pagination.on('click', '.pagination-inner .pagination-pages > div', function () {
		let $paginateButton = $(this);
		if ($paginateButton.hasClass('active')) {
			return false;
		}

		let newPageNumber = parseInt($paginateButton.attr('data-page'));
		$pagination.trigger('runPagination', [newPageNumber]);
	});

	// handle pagination direction buttons
	$pagination.on('click', '.pagination-inner .pagination-direction', function () {
		let direction = parseInt($(this).attr('data-dir'));
		$pagination.trigger('runPagination', [currentPage + direction]);
	});

	$form.trigger('updateFilter');
	$pagination.trigger('runPagination');
});

jQuery(function ($) {
	[
		{
			containerSelector: 'ul.products',
			itemSelector: '.sl-product',
			heighterSelector: '.woocommerce-loop-product__title',
		},
	].forEach(function (config) {
		let maxHeight = 0;
		const $container = $(config.containerSelector);
		const $items = $container.find(config.itemSelector);
		const $heighters = $container.find(config.heighterSelector);

		$items.each(function () {
			const $item = $(this);
			const height = $item.find(config.heighterSelector).height();
			maxHeight = Math.max(maxHeight, height);
		});

		$heighters.height(maxHeight);
	});
});

(function (w, $) {
	$.ajax({
		url: window.slendier.ajaxUrl + '?action=GetCartCount',
		method: 'POST',
	}).then(function (res) {
		$(function () {
			if (res.data && res.data.cartCount) {
				$('header .cart-count').html(res.data.cartCount).fadeTo(500, 1);
			}
		});
	});
})(window, jQuery);

jQuery(function ($) {
	const $d = $(document);

	function setCookie(name, value, days) {
		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + 24 * days * 60 * 60 * 1e3);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	}

	function getCookie(name) {
		let cookie = {};
		document.cookie.split(';').forEach(function (el) {
			let split = el.split('=');
			cookie[split[0].trim()] = split.slice(1).join('=');
		});
		return cookie[name];
	}

	function consentGrantedAdStorage() {
		// eslint-disable-next-line no-undef
		gtag('consent', 'update', {
			ad_storage: 'granted',
			ad_user_data: 'granted',
			ad_personalization: 'granted',
			analytics_storage: 'granted',
		});
	}

	$d.on('click', '.gdpr-container button', function () {
		$('.gdpr-container').removeClass('gdpr-container-visible');

		const value = $(this).attr('data-btn');

		setCookie('gdpr', value, 365);

		if (value === 'yes') {
			consentGrantedAdStorage();
		}
	});

	const gdprCookie = getCookie('gdpr');
	if (gdprCookie === 'yes') {
		consentGrantedAdStorage();
	} else if (gdprCookie === 'no') {
		// do nothing as it defaults to denied
	} else {
		setTimeout(function () {
			const $gdpr = $('.gdpr-container');
			if (!$gdpr.length) {
				return;
			}

			$gdpr.addClass('gdpr-container-visible');
		}, 2000);
	}
});
